var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qa-edit"},[_c('edit',{attrs:{"fs":_vm.qaEditFields,"id":_vm.id,"api":"qas","title":"Edit QA"},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }